import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/common/Primitives";

export function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "super_admin" ? "/admin" : user.role === "staff" ? "/staff" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}
